'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024proto$0024$002dStore$002dSeed from "./presto.types$proto$-Store-Seed.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$47() {
}
export { $c_Lpresto_TwoFactorAuthView$$anon$47 as $c_Lpresto_TwoFactorAuthView$$anon$47 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$47.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$47;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$47() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$47 as $h_Lpresto_TwoFactorAuthView$$anon$47 };
$h_Lpresto_TwoFactorAuthView$$anon$47.prototype = $p;
$p.sH = (function(x) {
  if ((x !== null)) {
    var x85 = x.Y();
    var x86 = x.X();
    if ((x85 !== null)) {
      var t = x85.xN;
      var x93 = x85.xO;
      if ((x93 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var x95 = x93.a0;
        if ((x95 instanceof $j_presto$002etypes$0024proto$0024$002dStore$002dSeed.$c_Lpresto_types$proto$StoreSeed)) {
          if ((x86 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
            return true;
          }
        }
      }
    }
  }
  return false;
});
$p.sv = (function(x, default$1) {
  if ((x !== null)) {
    var x100 = x.Y();
    var x101 = x.X();
    if ((x100 !== null)) {
      var t = x100.xN;
      var x108 = x100.xO;
      if ((x108 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some)) {
        var x110 = x108.a0;
        if ((x110 instanceof $j_presto$002etypes$0024proto$0024$002dStore$002dSeed.$c_Lpresto_types$proto$StoreSeed)) {
          var x113 = x110.MX;
          if ((x101 instanceof $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_util_Failure)) {
            return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2(x113, x101.ak.aM());
          }
        }
      }
    }
  }
  return default$1.v(x);
});
$p.ca = (function(x) {
  return this.sH(x);
});
$p.bk = (function(x, default$1) {
  return this.sv(x, default$1);
});
var $d_Lpresto_TwoFactorAuthView$$anon$47 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$47, "presto.TwoFactorAuthView$$anon$47", ({
  SJ: 1,
  a4: 1,
  t: 1,
  z: 1,
  a: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$47 as $d_Lpresto_TwoFactorAuthView$$anon$47 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$47.js.map
